declare type LoginPageDefinition = {
    hideGuestAccess: boolean;
};

export const defaultLoginConfig: LoginPageDefinition = {
    hideGuestAccess: false,
};
